var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-store"},[_c('top-bar',{attrs:{"title":_vm.app.name,"icon":"store","back-to":"/store"}}),_c('loading-overlay',{attrs:{"is-loading":_vm.loading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }